import { testimonials } from '@/mocks/testimonials';
import SectionShell from '@/components/feature/SectionShell';
import SectionHeader from '@/components/feature/SectionHeader';
import { ArmedGroup, moDelay } from '@/lib/motion/Reveal';

export default function ClientNotes() {
  return (
    <SectionShell id="client-notes" labelledBy="notes-title" surface="subtle">
      <SectionHeader index="05" name="Client Notes" titleId="notes-title" title="In their words" meta={`${testimonials.length} recent commissions`} />
      <ArmedGroup as="ul" className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-0">
        {testimonials.map((t, i) => (
          <li
            key={t.id}
            style={moDelay(0, i, 90)}
            className={`mo-aitem mo--note grid grid-rows-[1fr_auto] gap-8 md:min-h-[280px] md:px-8 ${i === 0 ? 'md:pl-0' : 'mo-rule'} ${i === testimonials.length - 1 ? 'md:pr-0' : ''}`}
          >
            <blockquote className="font-heading text-lg font-normal leading-[1.45] tracking-[-0.01em] text-foreground-950 md:text-[20px]">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <footer>
              <p className="text-[14px] font-medium text-foreground-950">{t.name}</p>
              <p className="mt-1 text-[13px] text-foreground-600">{t.role} — {t.brand}</p>
            </footer>
          </li>
        ))}
      </ArmedGroup>
    </SectionShell>
  );
}